import React, { lazy, Suspense, useContext } from "react";
import { Routes, Route, Navigate } from "react-router";
import {
  CREATE_PASSWORD,
  DASHBOARD,
  EMAILS_FOR_REVIEW,
  FAILED_EMAILS,
  FILL_APPLICATION_FORM,
  FIND_ENTITY_ID,
  FORGOT_PASSWORD,
  LOGIN,
  PROCESSED_EMAILS,
  RESOLVE_MANUALLY,
  SELECT_AGENT,
  SELECT_APPLICATION_FORM,
  SELECT_BANK_STATEMENTS,
  SETTINGS_LOGS,
  SETTINGS_PROFILE,
  UNPROCESSED_EMAILS,
  VERIFY_RECOVERY_CODE,
} from "./constants/routes";
import AuthLayout from "./layouts/AuthLayout";
import ProtectedRoute from "./components/routes/ProtectedRoute";

import LoginPage from "./pages/login-page";
import ForgotPasswordPage from "./pages/forgot-password-page";
import DashboardPage from "./pages/dashboard-page";
import ProcessedEmailsPage from "./pages/processed-emails-page";
import EmailsForReviewPage from "./pages/emails-for-review-page";
import UnprocessedEmailsPage from "@/pages/unprocessed-emails-page";
import FailedEmailsPage from "@/pages/failed-emails-page";
import SettingsProfilePage from "@/pages/settings-profile-page";
import SettingsLogsPage from "@/pages/settings-logs-page";
import ResolveManuallyPage from "@/pages/resolve-manually-page";
import VerifyRecoveryCodePage from "@/pages/verify-recovery-code-page";
import CreatePasswordPage from "@/pages/create-password-page";

import MainLayout from "./layouts/MainLayout";
import PageLoader from "./components/layout/PageLoader";
import { AuthContext } from "./context/AuthContext";

export default function App() {
  const { user, loadingUser } = useContext(AuthContext);

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={LOGIN} element={<LoginPage />} />
        <Route path={FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route
          path={VERIFY_RECOVERY_CODE}
          element={<VerifyRecoveryCodePage />}
        />
        <Route path={CREATE_PASSWORD} element={<CreatePasswordPage />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route path={DASHBOARD} element={<DashboardPage />} />
          <Route
            path={UNPROCESSED_EMAILS}
            element={<UnprocessedEmailsPage />}
          />
          <Route path={PROCESSED_EMAILS} element={<ProcessedEmailsPage />} />
          <Route path={EMAILS_FOR_REVIEW} element={<EmailsForReviewPage />} />

          <Route path={RESOLVE_MANUALLY} element={<ResolveManuallyPage />} />
          <Route
            path={SELECT_APPLICATION_FORM}
            element={<ResolveManuallyPage />}
          />
          <Route
            path={FILL_APPLICATION_FORM}
            element={<ResolveManuallyPage />}
          />
          <Route
            path={SELECT_BANK_STATEMENTS}
            element={<ResolveManuallyPage />}
          />
          <Route path={FIND_ENTITY_ID} element={<ResolveManuallyPage />} />
          <Route path={SELECT_AGENT} element={<ResolveManuallyPage />} />

          <Route path={FAILED_EMAILS} element={<FailedEmailsPage />} />
          <Route path={SETTINGS_PROFILE} element={<SettingsProfilePage />} />
          <Route path={SETTINGS_LOGS} element={<SettingsLogsPage />} />
        </Route>
      </Route>
      <Route 
        path="*" 
        element={
          loadingUser ? <PageLoader /> : (user ? <Navigate to={DASHBOARD} replace /> : <Navigate to={LOGIN} replace />)
        } 
      />
    </Routes>
  );
}
